import { isMobile } from 'react-device-detect';
import { ISignInsuranceDocumentsResponse } from '../generated/ApiClient';
import QRCode from 'qrcode.react';

export function SignatureQrCode({
  signDocument,
}: {
  signDocument: ISignInsuranceDocumentsResponse;
}) {
  return isMobile ? (
    <a href={signDocument.signDocumentUrl} target="_blank" rel="noreferrer">
      <QRCode size={300} value={signDocument.signDocumentUrl} />
    </a>
  ) : (
    <QRCode size={300} value={signDocument.signDocumentUrl} />
  );
}
